import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=3be8d863&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=js&"
export * from "./CouponItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=3be8d863&prod&lang=sass&scoped=true&"
import style1 from "./CouponItem.vue?vue&type=style&index=1&id=3be8d863&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8d863",
  null
  
)

export default component.exports